import StatCounter from "../ui/StatCounter";
import StaggerContainer from "../motion/StaggerContainer";

const stats = [
  { value: "500+", label: "Projects Delivered" },
  { value: "200+", label: "Clients Globally" },
  { value: "₹50Cr+", label: "Revenue Generated" },
  { value: "15", label: "Industries Served" },
];

export default function StatsBar() {
  return (
    <>
      <section
        style={{
          background: "#0E0E0E",
          padding: "80px 40px",
          borderTop: "0.5px solid rgba(212,168,67,0.12)",
          borderBottom: "0.5px solid rgba(212,168,67,0.12)",
        }}
      >
        <StaggerContainer stagger={0.12} className="owl-stats-grid" style={{ maxWidth: 1280, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(4,1fr)" }}>
          {stats.map((stat, index) => (
            <div key={stat.label} style={{ borderLeft: index > 0 ? "0.5px solid rgba(212,168,67,0.15)" : "none" }}>
              <StatCounter value={stat.value} label={stat.label} />
            </div>
          ))}
        </StaggerContainer>
      </section>

      <style>{`
        @media (max-width: 960px) {
          .owl-stats-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 40px 24px;
          }

          .owl-stats-grid > div:nth-child(odd) {
            border-left: none !important;
          }
        }
        @media (max-width: 500px) {
          .owl-stats-grid {
            grid-template-columns: 1fr !important;
            gap: 32px;
          }
          .owl-stats-grid > div {
            border-left: none !important;
          }
        }
      `}</style>
    </>
  );
}
